export enum LoiSubmissionStatus {
    WaitingResponse,
    UnderReview,
    Accepted,
    Rejected,
}
